import React from "react";

const ForumDiscussion = () => {


    return (

        <div className="tab-content dc-contentdoctab dc-haslayout www">
            <div className="dc-location-holder tab-pane fade" id="locations">
                <div className="dc-title">
                    <h4>Forum Discussion</h4>
                </div>
            </div>

            <div className="dc-consultation-content">
                <ul>
                    <li className="comment byuser comment-author-flores bypostauthor even thread-even depth-1 comment-entry clearfix dc-consultation-details" id="comment-194">
                        <figure className="dc-consultation-img dc-imgcolor1">
                            <img src="//css.meddylist.com//wp-content/uploads/2019/09/img-08-30x30.png" alt="Answer" />
                        </figure>
                        <div className="dc-consultation-title">
                            <h5>
                                <a href="//css.meddylist.com//health-forum/constipation-magnesium-citrate/">Constipation – Magnesium Citrate</a>
                                <em>September 12, 2019</em>
                            </h5>
                        </div>
                        <div className="dc-description"><p>deneme</p></div>
                    </li>
                    <li className="comment byuser comment-author-flores bypostauthor odd alt thread-odd thread-alt depth-1 comment-entry clearfix dc-consultation-details" id="comment-207">
                        <figure className="dc-consultation-img dc-imgcolor1">
                            <img src="//css.meddylist.com//wp-content/uploads/2019/09/Dermatology--30x30.png" alt="Answer" />
                        </figure>
                        <div className="dc-consultation-title">
                            <h5>
                                <a href="//css.meddylist.com//health-forum/my-stool-smells-extremely-foul-almost-rancid-what-could-be-wrong/">My stool smells extremely foul, almost rancid. What could be wrong?</a>
                                <em>September 12, 2019</em>
                            </h5>
                        </div>
                        <div className="dc-description"><p>dlfasjdklf</p></div>
                    </li>
                    <li className="comment byuser comment-author-flores bypostauthor even thread-even depth-1 comment-entry clearfix dc-consultation-details" id="comment-275">
                        <figure className="dc-consultation-img dc-imgcolor1">
                            <img src="//css.meddylist.com//wp-content/uploads/2019/09/img-08-30x30.png" alt="Answer" />
                        </figure>
                        <div className="dc-consultation-title">
                            <h5>
                                <a href="//css.meddylist.com//health-forum/constipation-magnesium-citrate/">Constipation – Magnesium Citrate</a>
                                <em>September 12, 2019</em>
                            </h5>
                        </div>
                        <div className="dc-description"><p>sadf</p></div>
                    </li>
                </ul>
            </div>

            {/* <div className="dc-shareprofile">
                <ul className="d-flex dc-tags-social">
                    <li className="dc-sharejob">Share Profile:</li>
                    <li className="dc-fb">
                        <a href="//www.facebook.com/sharer.php?u=https%3A%2F%2Fmeddylist.com%2Fdoctors%2Fflores-emily%2F" onclick="window.open(this.href, 'post-share','left=50,top=50,width=600,height=350,toolbar=0'); return false;">
                            <i className="fab fa-facebook-f"></i>
                        </a>
                    </li>
                    <li className="dc-twit">
                        <a href="//twitter.com/intent/tweet?text=Flores+Emily&amp;url=https%3A%2F%2Fmeddylist.com%2Fdoctors%2Fflores-emily%2F&amp;via=envato">
                            <i className="fab fa-twitter"></i>
                        </a>
                    </li>
                    <li className="dc-google-plus">
                        <a href="//plus.google.com/share?url=//css.meddylist.com//doctors/flores-emily/" onclick="window.open(this.href, 'post-share','left=50,top=50,width=600,height=350,toolbar=0'); return false;">
                            <i className="fab fa-google-plus-g"></i>
                        </a>
                    </li>
                    <li className="dc-instg">
                        <a href="//pinterest.com/pin/create/button/?url=//css.meddylist.com//doctors/flores-emily/&amp;media=//css.meddylist.com//wp-content/uploads/2019/09/asian-male-doctor-man-indian-wea-308x220.png&amp;description=Flores+Emily" onclick="window.open(this.href, 'post-share','left=50,top=50,width=600,height=350,toolbar=0'); return false;">
                            <i className="fab fa-pinterest-p"></i>
                        </a>
                    </li>
                </ul>
            </div> */}
        </div>
    );


};

export default ForumDiscussion;
